module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap2"
    }
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("U")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RÉ SHOT DOWN")]), _vm._v(" the old highway, driving ninety. His old police cruiser was still plenty fast, and he had very good tires on it. The lights and siren were gone. He tried to remember if this was the fourth or the third one that he had owned.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That Bart, Du Pré thought, my rich friend, he try to give me a Land Rover. I find out they are sixty thousand dollars, I tell him no good Métis drive a car cost more than three houses cost here. So he find me this. It is faster than all the others.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré saw the old Grange Hall ahead. White clapboard, a little building, smaller even than a schoolhouse. Some schoolhouses.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré glanced left and right. He saw Benny’s four-wheel drive pickup off on some benchland a half mile or so away from the road. Du Pré slowed down. He saw a pair of ruts that went down into the barrow pit and up the other side and into the scrub. The ruts had been driven in recently.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré turned and the heavy police cruiser wallowed down and up and then he floored it. He kept an eye on the center of the tracks, looking for boulders, but this wasn’t that kind of country. The rocks were up higher.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Then he hit one and he felt the transmission heave.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Shit!” he snarled. He slowed down. The transmission whined. He smelled hot coolant.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fuck me, Du Pré thought. Fuck me to death. Damn.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Benny Klein was sitting on the tailgate of his pickup. Du Pré parked the cruiser and he got out and walked to the sheriff. Benny was white and he was sweating even though the day was not warm.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Over there,” said Benny. He pointed toward some silvered boards piled haphazardly and clotted with the yellow skeletons of weeds from the last year.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("An old lambing shed, maybe, who knew?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré walked slowly toward the pile of wood. A magpie floated past, headed for the creek a mile away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré smelled the rotten flesh. Dead people, they smell deader than anything else. You smell a real dead person, you are smelling yourself someday, you never forget it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She was lying facedown on a patch of yellow earth. The coyotes had eaten parts of her. Her legs were chewed. She was naked. She was swollen and greenish brown.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré squatted down on his haunches. He rolled a cigarette. He lit it with the rope shepherd’s lighter his daughter Jacqueline had sent him from Spain, when she and her Raymond had gone there for a vacation.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Left me with all them babies, Du Pré thought, Madelaine not help me, Madelaine’s daughters, I die.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fourteen kids they got now. I don’t think she is through yet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré watched some maggots writhing under the dead girl’s skin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A gold chain glittered on her left ankle.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She had been blond.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré stood up and he walked around the body, a circle about six feet away. He brought the ground to his eyes, like he was tracking. He saw bombardier beetles struggling through the grass. Some tiny shards of green glass shone against the ocher earth.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Couple paper towels, slumped against a sagebrush. Been here a while. Yellow stains on them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré circled out another two feet. The sagebrush was sparse here and clumps of grama grass spotted the harsh earth.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Rusty piece of barbwire, sticking out of the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré ground his cigarette out under his bootheel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He circled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He stopped the fourth time he’d walked slowly around, counterclockwise.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked back at the road. He rolled another cigarette and he walked back to Benny, still sitting on the tailgate of the truck.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who finds her?” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“One of the Salyer kids,” said Benny. “Hunting gophers.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That kid not going to sleep so good, next month of nights.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Your dispatcher, she call the State?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré detested the dispatcher, who was a stupid bitch.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah,” said Benny. “They’re on their way. Probably be here, an hour. Said not to disturb anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré snorted. Same old shit.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“This not good,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No,” said Benny. “It ain’t. This animal is doing this, dumping the bodies. I just thought, shit, I bet there’s a lot more. A lot more.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He glanced over toward a movement just out of his line of vision. A magpie had flown up from the sagebrush a couple hundred yards away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We never had anything like this before,” said Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A white pickup roared past on the road. The driver waved. Du Pré and Benny waved back.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the night, Du Pré thought, a man could drive here, cut his lights, carry the bodies here in maybe ten, fifteen minutes, drive away, not turn his lights on till he was back on the highway. Have to have a lot of gas, couldn’t afford to be seen buying any.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Benny’s radio began to squawk.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Benny stood up and walked around to his cab and reached in and got the microphone. He listened for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Of course I’ll stay here,” he said, angrily. “What the hell do you think I am gonna do? Go play cards?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well,” the dispatcher’s whiny voice said, “they asked me to call you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We actually wipe our butts and everything here, Iris,” said Benny. “Those bastards are not going to be pleasant to have around.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I was just trying to do my job …” whined Iris.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK, OK,” said Benny. He clicked the microphone off.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Poor Iris,” said Benny. “Husband up and left, she’s got six kids and two of them got in trouble and sent to Pine Hills.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked at Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Me,” he said, “I don’t be surprised her husband left, her kids are in jail. She is …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I know,” said Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Benny walked morosely back to the tailgate and he sat down.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Could I have a smoke?” said Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré rolled him one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I don’t need this shit,” said Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré nodded. It is your shit, though, Benny, you are the sheriff.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That poor girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré stretched. He glanced off to his left:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Another magpie, same place.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Shit.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK,” said Du Pré. “I think there is another one over there, so, Benny, why don’t you just sit here, smoke.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh, God,” said Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré got up and he started off toward the dark smear of sage that ran across his vision, there must be a slab of rock under it that caught water and held it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Another magpie.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Shit.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré kept glancing down at the ground at his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was moving fast now, dancing through the sagebrush.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré heard drums in his head.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He smelled the smell of dead people, dead long enough to rot.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked hard.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He saw them then.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Two of them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked hard and he drifted to his right, circling.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Two bodies, naked, laid out one atop the other, crossed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré closed in. He rolled a smoke and lit it, to cut the smell.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He wished he’d brought a bottle with him from his car.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A sudden whiff of skunk. Du Pré saw the black-and-white creature waddling away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("These were awfully small women. Girls, really.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They had both been blond. The magpies and the scavengers had been at their faces. Flies buzzed around the eyepits. Their bellies were hugely swollen and the skin glazed with dirt.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("These were fresher than the other, Du Pré thought, few days old.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He spat on the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He moved away and he began to circle.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Him, Du Pré thought, he maybe leave more here.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Him, he like this place.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Why?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f618f01","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/6chap2.vue
// module id = 87
// module chunks = 0